<template>
  <div>
    <v-dialog v-model="stockDialog" persistent max-width="1000">
      <v-card class="px-6">
        <v-card-title class="px-4 px-4 pb-0">
          <span class="headline">All Stocks</span>
          <v-spacer></v-spacer>
          <span class="body-2"
            >All stocks on hand as of:
            {{ allStocks.updatedAt | formatDate }}</span
          >
        </v-card-title>
        <v-card-text class="pb-0 px-4 mb-3">
          <ag-grid-vue
            style="height: 80vh"
            class="ag-theme-balham mb-4"
            :gridOptions="gridOptions"
            @grid-ready="onGridReady"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            rowSelection="multiple"
            :rowData="allStocks"
            pagination
            suppressRowClickSelection
            rowMultiSelectWithClick
            paginationAutoPageSize
          ></ag-grid-vue>
          <loader-dialog
            :showLoader="showLoader"
            :stockDialog="stockDialog"
          ></loader-dialog>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="px-3 pb-3">
            <v-btn color="primary" medium @click="close()">Close</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LoaderDialog from "@/components/common/LoaderDialog";
import { AgGridVue } from "ag-grid-vue";
import { mapGetters } from "vuex";
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);

export default {
  name: "MiaStock",
  components: {
    AgGridVue,
    LoaderDialog,
  },
  props: {
    stockDialog: { type: Boolean, required: true },
  },
  data() {
    return {
      showLoader: false,
      gridOptions: null,
      columnDefs: null,
      defaultColDef: null,
      rowData: null,
      gridApi: null,
      search: "",
    };
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: "Store Display Name",
        field: "Store Display Name",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Internal ID",
        field: "internalID",
        sortable: true,
        filter: true,
      },
      {
        headerName: "On Hand Quantity",
        field: "On Hand Qty",
        sortable: true,
        filter: true,
        sort: 'desc'
      },
      {
        headerName: "UPC",
        field: "upc",
        sortable: true,
        filter: true,
      },
      {
        headerName: "SKU",
        field: "sku",
        sortable: true,
        filter: true,
      },
    ];

    vm.defaultColDef = {
      flex: 1,
      minWidth: 100,
    };
  },
  methods: {
    ...mapOrderActions(["getAllStock"]),
    onGridReady(params) {
      let vm = this;

      vm.gridApi = params.api;
    },
    close() {
      let vm = this;
      vm.gridApi.deselectAll();
      vm.$emit("close");
    },
  },
  computed: {
    ...mapGetters("orders", ["allStocks"]),
  },
  watch: {
    stockDialog: function () {
      let vm = this;
      if (vm.stockDialog) {
        vm.showLoader = true;
        vm.getAllStock().then(() => {
          vm.showLoader = false;
        });
      }
    },
  },
  filters: {
    formatDate: function (date) {
      if (!date) return null;

      const [year, month, day] = date.substring(0, 10).split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
